import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { billingReducer } from './ai-charge.reducer'
import { AIChargeEffects } from './ai-charge.effects'
import { AIChargeService } from './ai-charge.service'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('ai-charge', billingReducer),
    EffectsModule.forFeature([AIChargeEffects]),
  ],
  declarations: [],
  providers: [AIChargeService],
  exports: [],
})
export class AIChargeStoreModule {}
